var showAllChannelNav = function(){
  var body;

  var _init = function(){
    body = document.body;
    _showNav();
  };

  var _showNav = function(){
    if (body.classList.contains('is-regular-nav-channel')) {
      body.classList.remove('is-regular-nav-channel');
    }
    body.classList.add('is-all-channel-nav-channel');
  }

  var _hideNav = function(){
    body.classList.remove('is-all-channel-nav-channel');
  }


  return{
    init: _init,
    hide: _hideNav
  }
}();

module.exports = showAllChannelNav;